import axios from 'axios';
import { AutenticarTutoriaApiResponse, AutenticarTutoriaService } from './autenticar-tutoria.types';

export const autenticarTutoriaService: AutenticarTutoriaService = async ({
  urlBase,
  token,
  destinoPaginaZeroDuvidas,
  idTurma,
}) => {
  const authorization = `Bearer ${token}`;

  const { data } = await axios.post<AutenticarTutoriaApiResponse>(
    `${urlBase}/v3/zero-duvidas/tutoria`,
    { destinoPaginaZeroDuvidas, idTurma },
    { headers: { authorization } },
  );

  return { urlAutenticada: data.urlAutenticada };
};
